import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { Crop } from '@/types/Component';


@Component({
    components: {
        Modal
    }
})
export default class SelectCropModal extends Vue {
    // 作目一覧取得
    private crops: Crop[] = []
    // 左索引
    private firstCutoutChar: string[] = []
    // 上段索引
    private upperIndexes: string[] = []
    private choiseFirstCutoutCharStr: string | string[] = ''
    // 作目選択モーダル
    private latestCheckedCrops: Crop = {
        id: '',
        name: '',
        phonetic: ''
    }
    // 作目頭文字リスト
    private cropsInitialLines = [
        'アイウエオ',
        'カキクケコ',
        'ガギグゲゴ',
        'サシスセソ',
        'ザジズゼゾ',
        'タチツテト',
        'ダヂヅデド',
        'ナニヌネノ',
        'ハヒフヘホ',
        'バビブベボ',
        'パピプペポ',
        'マミムメモ',
        'ヤユヨ',
        'ラリルレロ',
        'ワヲン'
    ]

    @Prop()
    private value!: boolean

    @Prop()
    private checkedCrop!: Crop

    get showCropsModal(): boolean {
        return this.value
    }

    set showCropsModal(value: boolean) {
        this.value
    }

    @Watch('showCropsModal')
    private onChangeShowCropModal() {
        this.getCropsList()
    }

    // 作目一覧取得
    private getCropsList() {
        this.crops = []
        const firstCharSet: Set<string> = new Set()
        this.$apiClient.doRequest('get', '/crops').then((res)=>{
            this.crops = res.crops;
            this.crops.forEach((item: Crop) => {
                firstCharSet.add(item.phonetic.charAt(0))
            });
            this.firstCutoutChar = Array.from(firstCharSet).sort();
            // 上段索引は「あ」段のみ
            const initialLines = this.cropsInitialLines.filter(initialLine => this.firstCutoutChar.find(char => initialLine.includes(char)))
            this.upperIndexes = initialLines.map(line => line[0])

            this.latestCheckedCrops = this.checkedCrop
            if(this.checkedCrop) {
                this.choiseFirstCutoutCharStr = this.checkedCrop.phonetic.charAt(0)
            }else {
                this.choiseFirstCutoutCharStr = this.firstCutoutChar[0]
            }
        })
    }

    private choiseFirstCutoutCharList(cropName: string) {
        const str = this.cropsInitialLines.find(initialLine => initialLine.includes(cropName))
        if(str) {
            this.choiseFirstCutoutCharStr = str.split('')
        }
    }

    private choiseFirstCutoutChar(cropName: string) {
        this.choiseFirstCutoutCharStr = cropName
    }

    private isDisplayCropsNameUpper(name: string) {
        const str = this.cropsInitialLines.find(initialLine => initialLine.includes(name))
        if(typeof this.choiseFirstCutoutCharStr === 'string') {
            return str && str.indexOf(this.choiseFirstCutoutCharStr) > -1
        } else {
            return this.choiseFirstCutoutCharStr.includes(name)
        }
    }

    private isDisplayCropsName(name: string){
        if(typeof this.choiseFirstCutoutCharStr === 'string') {
            return this.choiseFirstCutoutCharStr === name
        } else {
            return this.choiseFirstCutoutCharStr.includes(name)
        }
    }

    private filteredCrops(): Crop[] {
        if(typeof this.choiseFirstCutoutCharStr === 'string') {
            return this.crops.filter(c => c.phonetic.charAt(0) === this.choiseFirstCutoutCharStr).sort(this.sortByPhonetic)
        } else {
            return this.crops.filter(c => this.choiseFirstCutoutCharStr.includes(c.phonetic.charAt(0))).sort(this.sortByPhonetic)
        }
    }

    private sortByPhonetic(crop1: Crop, crop2: Crop): number {
        return crop1.phonetic > crop2.phonetic
            ? 1
            : crop1.phonetic === crop2.phonetic
                ? 0
                : -1
    }

    @Emit('save')
    private save() {
        return this.latestCheckedCrops
    }

    @Emit('cancel')
    private cancel() {
        this.latestCheckedCrops = {
            id: '',
            name: '',
            phonetic: ''
        }
        if(this.checkedCrop){
            this.choiseFirstCutoutCharStr = this.checkedCrop.phonetic.charAt(0)
        } else {
            this.choiseFirstCutoutCharStr = this.firstCutoutChar[0]
        }
        this.showCropsModal = false
    }
}